import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-profilesettingcard',
  imports: [CommonModule],
  templateUrl: './profile-setting-card.component.html',
  styleUrl: './profile-setting-card.component.css'
})
export class ProfilesettingcardComponent {
  @Input() imageSource!: string;
  @Input() cardTitle!: string;
  @Input() isActive!: boolean;
  @Input() isShow!: boolean;
  @Input() cardDescription!: string;
  @Output() onCardClick = new EventEmitter<any>();
  

  onCardHandler(){
    this.onCardClick.emit();
  }
}
